(function($) {

  /**
   * A quick jQuery plugin to make our sidebar menu behavior generic
   * Apply to a parent container
   */
  Drupal.behaviors.paddingIconMenu = {
    attach: function(context, settings) {

      $.fn.paddingIconMenu = function(options) {

        // Smoosh settings together with defaults
         var settings = $.extend({
            trigger: ".level-1",
            parent: "li",
            activeClass: "is-active"
        }, options );

        // Clicking an expand-o menu
        this.on('click', settings.trigger, function(event) {

          var $parentItem = $(this).parent(settings.parent), // parent wrapper
            itemOffset = $(this).offset(), // offset from left/top
            relX = event.pageX - itemOffset.left, // where did click event happen
            iconPadding = parseInt($(this).css('padding-right'), 10); // icon should be here

          // If on the icon (padding to the right), only expand menu
          if ($(this).width() - relX <= iconPadding) {
            event.preventDefault();
            // Item is NOT active
            if (!$parentItem.hasClass(settings.activeClass)) {
              // Remove all active states
              $('.'+settings.activeClass, event.delegateTarget).removeClass(settings.activeClass);
            }
            // Toggle on active state
            $parentItem.toggleClass(settings.activeClass);
          }
        }); // .on

        // for chaining
        return this;
      };
    }
  };

  /**
   * Customer service sidebar nav behavior
   */
  Drupal.behaviors.ELB_navaccordion = {
    attach: function(context, settings) {
      // apply our custom jQuery pugin
      if (typeof paddingIconMenu != "undefined") {
        $('.sidebar-page__sidebar').paddingIconMenu({activeClass: "sidebar-link--is-active"});
      }
    }
  };

  /**
   * Customer service FAQ behavior
   */
  Drupal.behaviors.ELBfaq = {
    attach: function(context, settings) {
      var activeClass = 'faq--active';

      function _faqSection () {

      }
      $('.customer-service--faqs').on('click', '.faq__question', function(event){
        // only add class if we're clicking on element with no active state
        if ($(this).parent('.faq').hasClass(activeClass)) {
          $('.faq', event.delegateTarget).removeClass(activeClass);
        } else {
          $('.faq', event.delegateTarget).removeClass(activeClass);
          $(this).parent('.faq').addClass(activeClass);
        }
      });
      if (window.location.hash) {
        var hashVal = window.location.hash;
        var $section = $(hashVal,'.faq_sections');
        if ($section.length > 0) {
          var hashPosition = $section.offset().top - 90;
          $('body, html').animate({
            scrollTop: hashPosition
          }, 1000, function () {
            if ($section.hasClass('faq__question')) {
              $section.parent('.faq').addClass('faq--active');
            }
          });
        }
      }
    }
  };

})(jQuery);
